import { gql, useLazyQuery } from '@apollo/client'
import { Button, Stack } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const OPERATION_TRANSLATION = gql`
  query PortalAdvertisementTranslations($header: String!, $body: String!) {
    translations: portalAdvertisementTranslations(header: $header, body: $body) {
      field
      fr
      en
      es
      de
    }
  }
`

const TRANSLATABLE_FIELDS = ['header', 'body']

const TranslationButton = ({ selectedTab, replace }) => {
  const { t } = useTranslation()
  const { getValues, setValue, trigger, watch } = useFormContext()
  const activeContent = watch(`contents.${selectedTab}`)
  const [translateAdvertisement, { loading }] = useLazyQuery(OPERATION_TRANSLATION, {
    fetchPolicy: 'no-cache'
  })
  const isDisabled = loading || !activeContent?.header?.trim() || !activeContent?.body?.trim()

  const handleTranslate = async () => {
    const contents = getValues('contents') || []
    const activeContent = contents[selectedTab]

    if (!activeContent) {
      return
    }

    const { data } = await translateAdvertisement({
      variables: {
        header: activeContent.header || '',
        body: activeContent.body || ''
      }
    })
    const translations = data?.translations || []
    const translatedContents = contents.map(content => ({ ...content }))

    translations.forEach(translation => {
      if (!TRANSLATABLE_FIELDS.includes(translation.field)) {
        return
      }

      translatedContents.forEach((content, index) => {
        const translatedValue = translation[content.language]

        if (content.language === activeContent.language || !translatedValue) {
          return
        }

        translatedContents[index] = {
          ...content,
          [translation.field]: translatedValue
        }
      })
    })

    replace(translatedContents)
    setValue('contents', translatedContents, {
      shouldDirty: true,
      shouldValidate: true
    })
    trigger('contentCompleted')
  }

  return (
    <Button
      type="button"
      size={'sx'}
      sx={{
        marginTop: '24px',
        backgroundColor: '#DBE8FE',
        height: '36px',
        color: '#2570EB',
        '&:hover': {
          backgroundColor: '#C5D7FD'
        }
      }}
      variant={'contained'}
      onClick={handleTranslate}
      disabled={isDisabled}>
      {loading ? (
        <Stack alignItems={'center'} gap={1} direction={'row'}>
          <i className={'fa-light fa-spinner fa-spin'} />
          {t('advertisements.button_translate_processing')}
        </Stack>
      ) : (
        t('advertisements.button_translate')
      )}
    </Button>
  )
}

export default TranslationButton
